import { useScenario } from "../../contexts/ScenarioContext"

import MDBModal from "./MDBModal"

import PatientStatus from "../PatientStatus"


const FindingsModal = () => {
    const { showFindings, dismissFindings } = useScenario()

    return (
        <MDBModal
            name="Patient Status"
            show={showFindings}
            dismiss={dismissFindings}
        >
            <PatientStatus />
        </MDBModal>
    )
}


export default FindingsModal